import { Component, input } from '@angular/core';

@Component({
    selector: 'lib-redacted',
    imports: [],
    template: `<ng-content></ng-content>`,
    host: {
        '[style.filter]': "'blur(' + this.blur() + ')'",
    }
})
export class RedactedComponent {
  blur = input<string>('0.25rem');
}
